import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { UserAccountRegDto } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { RegistrationService } from 'src/app/core/services/registration.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'app-test-taker-complaint',
  templateUrl: './test-taker-complaint.component.html',
  styleUrls: ['./test-taker-complaint.component.scss']
})
export class TestTakerComplaintComponent implements OnInit {

  @ViewChild("scoreWarning") scoreWarning: ModalComponent;
  regId: number;
  testInfo: UserAccountRegDto;
  comments: string;
  additionalComments: string;
  warningMesssage: string;
  maxWordsForSummary = 20;
  maxWordsForAdditional = 400;

  constructor(
    private activatedRoute: ActivatedRoute,
    private registrationService: RegistrationService,
    private router: Router,
    private toastService: HotToastService,

  ) {
    this.regId = Number(this.activatedRoute.snapshot.params.regId);
  }

  ngOnInit(): void {
    this.warningMesssage = "Submitting this report may delay the release of your CELPIP Scores. Do you wish to proceed?";
    this.getRegistrationDetails();
  }

  getRegistrationDetails() {
    this.registrationService.getTestInfo(this.regId)
      .subscribe(
        (result) => {
          this.testInfo = result.content;
        },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
        });
  }

  displayModal() {
    if (this.validateComments()) {
      this.scoreWarning.open();
    }
  }

  submitComplaint() {
    this.scoreWarning.close();
    this.registrationService.CreateRegScoreFlag(this.regId, this.comments, this.additionalComments)
      .subscribe(
        () => {
          this.toastService.success("Your complaint has been successfully submitted");
          this.redirectToMyAccount();
        },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
          else {
            this.toastService.warning("Failed to submit your complaint. Please contact Paragon");
          }
        });
  }

  validateComments() {
    let isValid = true;
    const htmlTagRegex = /<[^>]*>/g;
    if (htmlTagRegex.test(this.comments)) {
      this.toastService.warning("Your report should only contain letters and numbers. Please avoid using HTML tags, such as <, >, and other special characters.");
      isValid = false;
    }
    if (htmlTagRegex.test(this.additionalComments)) {
      this.toastService.warning("Your report should only contain letters and numbers. Please avoid using HTML tags, such as <, >, and other special characters.");
      isValid = false;
    }
    if (this.comments.match(/\n/g)) {
      this.toastService.warning("New lines are not allowed in the summary. Please remove any line breaks from your input.");
      isValid = false;
    }
    if (this.comments.split(' ').length > this.maxWordsForSummary) {
      this.toastService.warning(`Summary must be ${this.maxWordsForSummary} words or fewer.`);
      isValid = false;
    }
    if (this.additionalComments.split(' ').length > this.maxWordsForAdditional) {
      this.toastService.warning(`Comments should not exceed ${this.maxWordsForAdditional} words.`);
      isValid = false;
    }
    return isValid;
  }

  redirectToMyAccount() {
    this.router.navigate(['my-account']);
  }

}
